import { START_CHAT_EVENT } from "../Settings/constants";

/**
 * Calculates number of days difference between two timestamps
 * @param {string|number|Object} timestampA First timestamp value. Format can be anything accepted by the Date() constructor.
 * @param {string|number|Object} timestampB Second timestamp value. Format can be anything accepted by the Date() constructor.
 * @returns {number} Number of days inbetween dates.
 */
export const calculateDaysBetweenTimestamps = (timestampA, timestampB) => {
  if (!timestampA || !timestampB) {
    return null;
  }
  const millisecsSinceEpochA = new Date(timestampA).getTime();
  const millisecsSinceEpochB = new Date(timestampB).getTime();
  let differenceInDays;
  if (typeof millisecsSinceEpochA === "undefined" || typeof millisecsSinceEpochB === "undefined" || Number.isNaN(millisecsSinceEpochA) || Number.isNaN(millisecsSinceEpochB)) {
    // One or more parameters are undefined or in wrong format
    return null;
  }
  differenceInDays = Math.abs(millisecsSinceEpochA - millisecsSinceEpochB) / 86400000; // Divide by the number of millisecs in a day

  return parseFloat(differenceInDays.toFixed(2));
};

/**
 * Opens Boost chatbot depending on if it is configured on the page
 * @param {Object} e Event object for preventing default click behaviour if passed
 */
export const openChatbot = e => {
  const start = new Event(START_CHAT_EVENT);
  const chatbot = document.getElementById("chat-container");
  if (chatbot) {
    e?.preventDefault();
    chatbot.dispatchEvent(start);
  }
};
export const pushToDatalayer = (clickType, bannerType, headingName, linkName) => {
  if (typeof window.dataLayer !== "undefined" && window.dataLayer.length > 0) {
    window.dataLayer.push({
      "event": "banner_interaction",
      "banner_name": headingName,
      "banner_click_type": clickType,
      "banner_link_click": linkName ? linkName : "",
      "banner_type": bannerType
    });
  }
};
export const findObjectByKey = (obj, key, value) => {
  for (let prop in obj) {
    if (Object.hasOwn(obj, prop) && obj[prop][key] === value) {
      return obj[prop];
    }
  }
  return null;
};